import { SubCategoryItem, ThirdCategoryItem } from "@jog/shared"
import { useCallback, useMemo, useState } from "react"

export const useMobileNav = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [subMenus, setSubMenus] = useState<SubCategoryItem[]>([])
    const [thirdMenus, setThirdMenus] = useState<ThirdCategoryItem[]>([])
    const [activeMainMenu, setActiveMainMenu] = useState<string>("")
    const [activeSubMenu, setActiveSubMenu] = useState<string>("")
    const mainMenuShow = useMemo(() => !subMenus.length && !thirdMenus.length, [subMenus.length, thirdMenus.length])
    const subMenuShow = useMemo(() => subMenus.length && !thirdMenus.length, [subMenus.length, thirdMenus.length])
    const hideMenu = useCallback(() => {
        setSubMenus([])
        setActiveMainMenu("")
        setThirdMenus([])
        setActiveSubMenu("")
        setIsOpen(false)
    }, [])

    return {
        isOpen,
        setIsOpen,
        mainMenuShow,
        subMenuShow,
        hideMenu,
        subMenus,
        setSubMenus,
        thirdMenus,
        setThirdMenus,
        activeMainMenu,
        setActiveMainMenu,
        activeSubMenu,
        setActiveSubMenu,
    }
}
